<script>
	import {user, view, change_attribute, send_data} from "../client.svelte.js";
	import Sheet from "./Sheet.svelte";
	import Sidebar from "../elements/Sidebar.svelte";
	import {field, textblock} from "./SheetFields.svelte";
	import PortraitDialog from "../dialogs/PortraitDialog.svelte";
	import HeroImages from "../dialogs/HeroImages.svelte";

	let { disabled = true } = $props()
	let portraitPicker, imageManager
	let editText = $state(null)		// id of the long text currently edited

	const descFields = [
		{id: 'name', label: "Name", span: 2}, {id: 'level', label: "Stufe", numeric: true, fixed: true},
		{id: 'vocation', label: "Beruf"}, {id: 'race', label: "Volk"}, {id: 'age', label: "Alter", unit: "Jahre", numeric: true},
		{id: 'origin', label: "Herkunft", span: 2}, {id: 'height', label: "Größe", unit: "cm", numeric: true},
		{id: 'face', label: "Angesicht", span: 2}, {id: 'weight', label: "Gewicht", unit: "kg", numeric: true},
		{id: 'physique', label: "Figur", span: 2}]
	const texts = [{id: 'narrative', title: "Geschichte"}, {id: 'backstory', title: "Hintergrund"}]

	let portraitVersion = $state(0)		// bumped after upload, so the browser reloads the (same) token URL

	/** receives the cropped portrait from the Portrait dialog and uploads it **/
	async function upload_portrait(file) {
		console.log(`HERO: Upload new portrait for ${view.character.ID}:`, file)
		await send_data(`/character/${view.character.ID}`, {}, 'PATCH', file)
		portraitVersion++
	}

	function change_descript(e) {
		if (e.target.type === 'file')  return
		change_attribute.bind(view.character)(e)
	}
</script>

<!-------------------------------- HTML -------------------------------------->

<section id="description" onchange={change_descript}>
	<!-- action button sits  in the navigation bar, top right -->
	<Sidebar items={[
		{id: 'images', icon: 'image', label: "Bilder verwalten", primary: true, onclick: () => imageManager.open()} ]}/>

	<Sheet>
		<div class="upper">
			<figure class="portrait" data-help="portrait">
				<button class="plate" {disabled} title={view.character.ID} onclick={() => portraitPicker.pick()}>
					{#if view.character.tokenURL}
						<img src={portraitVersion ? `${view.character.tokenURL}?v=${portraitVersion}` : view.character.tokenURL} alt="Portrait"/>
					{:else}
						<span class="fa icon-image"></span>
						<span class="plate-hint">Portrait hochladen</span>
					{/if}
				</button>
				{#if !disabled}<figcaption class="hint">Klicken zum Ändern</figcaption>{/if}			</figure>

			<div class="fields">
				{#each descFields as f}
					{@render field({...f, value: view.character[f.id], disabled: disabled || f.fixed})}
				{/each}
			</div>
		</div>

		{@render textblock({id: 'narrative', title: "Geschichte", value: view.character.narrative, disabled, editing: editText === 'narrative',
		                    ontoggle: () => editText = (editText === 'narrative') ? null : 'narrative'})}
		{#if user.ID === view.character.owner || user.ID === view.fellowship?.admin}
			{@render textblock({id: 'backstory', title: "Hintergrund", value: view.character.backstory, disabled, editing: editText === 'backstory',
			                    ontoggle: () => editText = (editText === 'backstory') ? null : 'backstory'})}
		{/if}
	</Sheet>
</section>

<PortraitDialog bind:this={portraitPicker} id='portrait-dialog' onselect={upload_portrait}/>
<HeroImages bind:this={imageManager} id='hero-images' hero={view.character} {disabled}/>


<!-------------------------------- STYLE -------------------------------------->

<style lang="sass">
	@use "../colors" as colors

	.upper
		margin: 2em 0 0
		display: grid
		grid-template-columns: 260px minmax(0, 1fr)
		gap: 40px
		align-items: start

	.portrait
		margin: 0

	.plate
		width: 260px
		height: 260px
		padding: 0
		display: flex
		flex-direction: column
		align-items: center
		justify-content: center
		gap: 8px
		background: var(--color-surface)
		border: 6px solid var(--color-surface)
		outline: 1px solid var(--color-divider)
		color: var(--color-neutral-600)
		filter: sepia(.22) saturate(.82) contrast(1.05)
		cursor: pointer

		&:disabled
			cursor: default

		img
			width: 100%
			height: 100%
			object-fit: cover

		.fa
			font-size: 26px

	.plate-hint
		font-size: 12px
		font-style: italic

	.hint
		margin-top: 8px
		text-align: center
		font-size: 11px

	.fields
		display: grid
		grid-template-columns: minmax(0, 2fr) minmax(0, 2fr) minmax(0, 1fr)
		gap: 22px 28px
</style>
